/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 10/24/20
 * Time: 12:16 PM
 */
import React, {Component} from 'react';
import {Col, Row} from "reactstrap";

import {Button} from "semantic-ui-react";
import {MDBModal} from "mdbreact";
import * as actionCreator from "../../../../store/Action";
import {connect} from "react-redux";
import * as healthConstants from "../../../../const/health/Health";
import {withTranslation} from "react-i18next";

class App extends Component {
  render() {
    const {t} = this.props;
    let {obj,guestQRIsCovidDetails,corporateId} = this.props;
    let customArray = [];
    if(guestQRIsCovidDetails){


      let incrementCount = 1;
      if (obj.covidQuestionResponses.length !== 0) {
        let selectedDynamicList = healthConstants.GUEST_FILTER_CORPORATE_COVID.find(obj => obj.corporateId === corporateId);
        obj.covidQuestionResponses.map((obj, index) => {
          let condition = false;
          if (selectedDynamicList && selectedDynamicList.selectedQuestions.length !== 0) {
            selectedDynamicList.selectedQuestions.map((selectObj, index) => {
              if (obj.questionId === selectObj) condition = true;
            })
          }
          if (condition) {
            customArray.push({questionId: incrementCount,question: obj.question, response: obj.response})
            incrementCount++;
          }
        })
      }

      // if(obj.covidQuestionResponses && obj.covidQuestionResponses.length !==0){
      //   obj.covidQuestionResponses.map((covidObj,index)=>{
      //     if(covidObj.questionId === 1 || covidObj.questionId === 2 || covidObj.questionId === 4){
      //       customArray.push({questionId: covidObj.questionId === 4 ? 3 : covidObj.questionId,question: covidObj.question, response: covidObj.response})
      //     }
      //   })
      // }
    }

    return guestQRIsCovidDetails ?
      <div>
        <MDBModal isOpen={true} toggle={this.props.closeModal} size="md">
          <div className={"covid-modal"}>
            <h4 className={"reg-form-main-topic"}>{`(${obj.key}) COVID Result | ${obj.visitorName} - ${obj.visitorMobile}`}</h4>
            <Row>
              <Col xs={12}>
                {/*{*/}
                  {/*obj.covidQuestionResponses && obj.covidQuestionResponses.length !== 0 && obj.covidQuestionResponses.map((question,index)=>{*/}
                    {/*return <div key={index} className={`covid-result-wrapper ${question.response? `covid-result-true`:`covid-result-false`}`}>*/}
                        {/*{`(${question.questionId}) ${question.question}`}*/}
                    {/*</div>*/}
                  {/*})*/}
                {/*}*/}
                {
                  customArray && customArray.length !== 0 && customArray.map((question,index)=>{
                    return <div key={index} className={`covid-result-wrapper ${question.response? `covid-result-true`:`covid-result-false`}`}>
                      {`(${question.questionId}) ${question.question}`}
                    </div>
                  })
                }
              </Col>
              <Col xs={12} className={"align-center"}>
                <Button className="px-5" onClick={this.closeModalHandler}>{t('close')}</Button>
              </Col>
            </Row>
          </div>
        </MDBModal>
      </div>
    :null
  }
  closeModalHandler = () => {
    this.props.setQRCovidResultViewer({guestQRIsCovidDetails: false, guestQRCovidObj: null});
  }
}

const mapStateToProps = (state) => ({
  guestQRIsCovidDetails: state.guestUserReducer.guestQRIsCovidDetails,
  obj: state.guestUserReducer.guestQRCovidObj,
});

const mapDispatchToProps = (dispatch) => {
  return {
    // view covid result
    setQRCovidResultViewer: (data) => dispatch(actionCreator.setQRCovidResultViewer(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(App));
